import { Grid } from "antd";

const { useBreakpoint } = Grid;

function PremiseDetailStyle() {
  const breakpoints = useBreakpoint();

  const Component = (() => {
    if (breakpoints.xxl){
        return {
            width: 400,
            height: 220
          };
    }
    
    if (breakpoints.xl){
        return {
            width: 350,
            height: 220
          };
    }
    
    if (breakpoints.lg){
        return {
            width: 300,
            height: 220
          };
    }
    

    if (breakpoints.md){
        return {
            width: 400,
            height: 210
          };
    }
    

    if (breakpoints.sm){
        return {
            width: 260,
            heigh: 220
          };
    }
    

    if (breakpoints.xs){
        return {
            width: 240,
            height: 240
          };
    }
  
  })();

  return {
    Component
  };
}

export default PremiseDetailStyle;